import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IconService } from './icon.service';

@Component({
    selector: 'mlp-ng-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class IconSharedComponent {
    private _name: string;
    @Input('name') set setIconName(value: string) {
        this._name = value.replace(' ', '-');
    }

    path = '';

    constructor(userService: IconService) {
        this.path = userService.symbolDefPath;
    }

    get name(): string { return this._name; }
}
